<section class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">
  <mat-drawer-container>
    <mat-drawer [mode]="'side'" [opened]="false" [position]="'end'" [disableClose]="true" #matDrawer>
      <router-outlet></router-outlet>
    </mat-drawer>
    <mat-drawer-content>
      <section class="content" [ngClass]="{ 'overflow-auto': tasksView === 'gantt' }">
        <!-- Header -->
        <ts-page-header>
          <ng-container page-header-title>
            <section class="flex items-center">
              <ts-button
                type="icon"
                color="accent"
                icon="menu"
                [matTooltip]="'Hide/show sidebar'"
                class="cursor-pointer"
                (click)="toggleDrawer()"
              ></ts-button>
              <div class="ml-2">
                <h5 class="m-0 leading-none">{{ taskList?.name }}</h5>
                <span>{{ taskList?.task_count }} tasks</span>
              </div>
            </section>
          </ng-container>
          <ng-container page-header-action-buttons>
            <section class="flex flex-row gap-2">
              <ts-button
                variant="secondary"
                icon="ts_file-save"
                (click)="openTaskExportDialog()"
                [appAuthorize]="getTaskListSharingRecordsPermission()"
                >Export</ts-button
              >
              <ts-button
                icon="add"
                color="primary"
                [matTooltip]="'Add new section'"
                (click)="createTask({ taskType: 'section' })"
              >
                Add Section
              </ts-button>
            </section>
          </ng-container>
          <ng-container page-header-action-bar>
            <section class="task-view__controllers flex items-center">
              <article class="views-wrapper">
                <ng-container *ngFor="let view of taskViewsConfig">
                  <span
                    class="lt-md:hidden view-option"
                    [matTooltip]="view.tooltip"
                    (click)="changeTasksView(view.name)"
                    [ngClass]="{ 'active-state': tasksView === view.name }"
                  >
                    <ts-icon [icon]="view.icon"></ts-icon>
                  </span>
                </ng-container>
              </article>

              <!-- User Association -->
              <section class="ml-4 mr-2 flex items-center w-full">
                <ng-container *ngFor="let userAssociation of userAssociations; let i = index">
                  <img
                    src="{{ userAssociation.user.avatar_url }}"
                    class="w-6 h-6 m-2px rounded-full text-card shadow-solid"
                    [ngClass]="{ '-ml-3': i > 0 }"
                    alt="{{ userAssociation.user.full_name }}"
                  />
                </ng-container>
                <ts-button
                  [appAuthorize]="getTaskListSharingRecordsPermission()"
                  type="icon"
                  color="accent"
                  icon="add_circle"
                  [matTooltip]="'Add User'"
                  [ngClass]="{ 'ml-2': userAssociations?.length > 0 }"
                  [tsOverlayTriggerFor]="userAssociationsOverlayBox"
                ></ts-button>
              </section>

              <!-- Refresh Tasks -->
              <ts-button
                [debounceTime]="500"
                type="icon"
                icon="refresh"
                color="black"
                class="lt-md:hidden"
                [matTooltip]="'Refresh'"
                (click)="refreshTasks()"
              ></ts-button>

              <!-- Search Bar -->
              <ts-input
                [formControl]="searchInputControl"
                type="text"
                icon="search"
                placeholder="Search"
                class="ml-2 search-bar"
              ></ts-input>

              <!-- Display Select Panel -->
              <app-column-selector
                *ngIf="tasksView === 'list' && canEditTaskLayout"
                class="ml-4"
                [matTooltip]="'Select columns'"
                [items]="taskFieldDefs"
                [selectedOrder]="selectedOrder"
                [draggable]="true"
                [showCountBadge]="true"
                [isButton]="true"
                (onSave)="onSaveColumns($event)"
              ></app-column-selector>

              <!-- List Filter Button -->
              <ts-button
                type="stroked"
                color="accent"
                class="ml-4"
                [tsOverlayTriggerFor]="filtersOverlayBox"
                [matTooltip]="'Apply filters'"
              >
                <ts-icon icon="ts_filter-list" class="mr-2"></ts-icon>
                Filter
                <ng-container *ngIf="filterCounter">
                  <ts-badge [value]="filterCounter" [type]="'info'"></ts-badge>
                </ng-container>
              </ts-button>
            </section>
          </ng-container>
        </ts-page-header>

        <!-- Loading Bar -->
        @if (isLoading) {
          <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
        }

        <!-- Kanban View -->
        @if (tasksView === 'kanban') {
          <div class="tasks-kanban">
            <div class="kanban-container" cdkDropListGroup>
              <div
                [ngClass]="{ 'kanban-group': true, 'no-data': groupedTasksByStatus[workflow.key]?.length === 0 }"
                [id]="workflow.key"
                *ngFor="let workflow of workflowStates; let i = index; trackBy: trackByFn"
                (cdkDropListDropped)="droppedKanban($event)"
                cdkDropList
                [cdkDropListData]="groupedTasksByStatus[workflow.key]"
                cdkDragBoundary=".kanban-container"
              >
                <div class="kanban-header">
                  <div class="kanban-item-title">{{ workflow.label }}</div>
                </div>
                <ng-container *ngIf="!(groupedTasksByStatus[workflow.key]?.length === 0)">
                  <treo-card
                    class="flex items-start justify-between p-3 m-0 mb-4 rounded border-l-4"
                    *ngFor="let task of groupedTasksByStatus[workflow.key]; let j = index; trackBy: trackByFn"
                    cdkDrag
                    [cdkDragData]="task"
                  >
                    <ng-container *ngIf="task?.id">
                      <div class="flex flex-col flex-1" [routerLink]="[task.id]">
                        <div class="text-base font-semibold leading-tight mb-1">
                          {{ task?.title || '-' }}
                        </div>
                        <div class="text-md text-primary leading-tight mb-1">
                          {{ getTaskStatusLabel(task?.workflow_state) || '-' }}
                        </div>
                        <div class="text-md text-secondary">
                          {{ task?.assigned_user_name || '-' }}
                        </div>
                      </div>
                      <button mat-icon-button [matMenuTriggerFor]="itemAction" class="self-start more-actions">
                        <mat-icon class="text-dark" [svgIcon]="'more_vert'"></mat-icon>
                      </button>
                      <mat-menu #itemAction="matMenu" class="kanban-dropdown-menu">
                        <button mat-menu-item class="py-4" (click)="deleteTask(task.id)">
                          <mat-icon [svgIcon]="'delete'"></mat-icon>
                          <span>Delete</span>
                        </button>
                      </mat-menu>

                      <div
                        *cdkDragPreview
                        id="kanban-preview"
                        class="flex items-start justify-between rounded border-l-4"
                      >
                        <div class="flex flex-col flex-1">
                          <div class="text-lg font-semibold leading-tight mb-1">
                            {{ task?.title || '-' }}
                          </div>
                          <div class="text-md text-primary leading-tight mb-1">
                            {{ getTaskStatusLabel(task?.workflow_state) || '-' }}
                          </div>
                          <div class="text-md text-secondary">
                            {{ task?.assigned_user_name || '-' }}
                          </div>
                        </div>
                      </div>
                      <div *cdkDragPlaceholder id="kanban-placeholder"></div>
                    </ng-container>
                  </treo-card>
                </ng-container>
              </div>
            </div>
          </div>
        }

        <!-- Gantt View -->
        @if (tasksView === 'gantt') {
          <gantt-chart-view (taskColumnClickEvent)="navigateToTask($event)"></gantt-chart-view>
        }

        <!-- List View -->
        @if (tasksView === 'list') {
          <main class="tasks-list">
            <ng-container *ngIf="tasks?.length > 0; else noTasks">
              <div class="h-full" [class.display-none]="isLoading">
                <ng-container *ngIf="tasks | taskFilter: searchedIds as filteredTasks">
                  <div
                    app-task-table
                    [isAggregatedTask]="false"
                    [tasks]="filteredTasks"
                    [selectedTask]="selectedTask"
                    [data]="routeData"
                    [users]="users"
                    [project]="project"
                    [taskStatuses]="workflowStates"
                    [selectedFields]="selectedFields"
                    (orderChanged)="onOrderChanged($event)"
                    (updateTask)="updateTask($event)"
                    (createTask)="createTask($event)"
                    (refreshTasks)="refreshTasks()"
                    (navigateToTask)="navigateToTask($event.id)"
                    (navigateToTaskComment)="onNavigateToTaskComment($event)"
                    [canEdit]="canEdit"
                  ></div>
                  <div class="no-tasks" *ngIf="!filteredTasks?.length">
                    <mat-icon [svgIcon]="'iconsmind:bulleted_list'"></mat-icon>
                    <h4>No data matching the filter</h4>
                  </div>
                </ng-container>
              </div>
            </ng-container>
            <ng-template #noTasks>
              <div class="no-tasks">
                <mat-icon [svgIcon]="'iconsmind:bulleted_list'"></mat-icon>
                <h4>Add a task to start planning!</h4>
              </div>
            </ng-template>
          </main>
        }

        @if (tasksView === 'calendar') {
          <div class="calendar-controls">
            <div class="calendar-controls__tools">
              <h4>
                {{ viewTitle }}
              </h4>
              <button class="previous" mat-icon-button (click)="previous()">
                <mat-icon [svgIcon]="'chevron_left'"></mat-icon>
              </button>
              <button class="next" mat-icon-button (click)="next()">
                <mat-icon [svgIcon]="'chevron_right'"></mat-icon>
              </button>
              <button class="lt-md:hidden" mat-icon-button (click)="today()">
                <mat-icon [svgIcon]="'today'"></mat-icon>
              </button>
            </div>
            <mat-form-field class="lt-md:hidden treo-mat-dense treo-mat-no-subscript view-changer">
              <mat-select (selectionChange)="changeView(viewChanger.value)" [value]="view" #viewChanger="matSelect">
                <mat-option [value]="'dayGridMonth'">Month</mat-option>
                <mat-option [value]="'timeGridWeek'">Week</mat-option>
                <mat-option [value]="'timeGridDay'">Day</mat-option>
                <mat-option [value]="'listYear'">Schedule</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="calendar">
            <full-calendar
              #fullCalendar
              [options]="calendarOptions"
              (eventRender)="onEventRender($event)"
              (datesRender)="onDatesRender()"
            ></full-calendar>
          </div>
        }
      </section>
    </mat-drawer-content>
  </mat-drawer-container>
</section>

<!-- User Associations Panel -->
<ts-overlay
  #userAssociationsOverlayBox
  position="bottom"
  [transparentBackdrop]="true"
  (closeByBackdropClick)="onUserAssociationPanelClose(newTagInput)"
>
  <div class="users-details-tags-panel">
    <div class="users-panel-header">
      <div class="new-user">
        <mat-icon [svgIcon]="'search'"></mat-icon>
        <input
          type="text"
          placeholder="Find user"
          (input)="filterUserAssociations($event)"
          (keydown)="filterUserAssociationsInputKeyDown($event)"
          #newTagInput
        />
      </div>
    </div>

    <div class="available-users">
      <ng-container>
        <mat-checkbox
          *ngFor="let userAssociation of filteredUserAssociations; trackBy: trackByFn"
          [color]="'primary'"
          [checked]="taskListUserIds.includes(userAssociation.user.id)"
          (change)="toggleUserAssociation(userAssociation, $event)"
          [disabled]="!userAssociation.user?.active"
        >
          {{ userAssociation.user.full_name }}
        </mat-checkbox>
      </ng-container>
    </div>
    <div appAuthorize="TASK_LIST_ADD_USER" class="create-user" (click)="openInvitationModal()" matRipple>
      <mat-icon [svgIcon]="'add'"></mat-icon>
      <div>Invite Guest User</div>
    </div>
  </div>
</ts-overlay>

<!-- List Filters Panel -->
<ts-overlay
  #filtersOverlayBox
  position="bottom"
  [transparentBackdrop]="true"
  (closeByBackdropClick)="onCloseByBackdropClick()"
>
  <ts-filter
    size="large"
    [fields]="typeFields | async"
    [filters]="filterValueList | async"
    [lookupContract]="lookupService"
    [hasGroups]="false"
    (addItem)="onAddFilterItem()"
    (filterDefChange)="onFilterDefChanged($event)"
    (filterRemove)="onFilterRemoved($event)"
    (filterClear)="onFilterCleared()"
    (filterApply)="onFilterApplied()"
  ></ts-filter>
</ts-overlay>
